module.exports = __webpack_public_path__ + "static/media/sticky-note.7099b45e.svg";